import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import SimpleLine from '../ChartComponents/SimpleLine';
import {
  statisticsCarBoxExcelDataRequest,
  statisticsCarBoxListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import { DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import { boxGrade, boxType } from '../../../../constants/nft';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Notification from '../../../../components/Notification/Notification';
import BtnIcons from '../../../../api/images/btnIcons';
import { DatePicker } from '@mui/x-date-pickers';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringMarket from "../../../../schema/table-schema/useSchemaMonitoringMarket";
import FetchLoading from "../../../../components/Loading/FetchLoading";
import DataItem from "../DataItem";
import {
  SearchBtnContainer,
  SearchContainer,
  SearchContent,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";

function carBox() {
  // -- component const --//
  // 상자 타입
  const boxTypes = Object.keys(boxType).map(key => ({
    key: boxType[key],
    value: key.toString(),
  }));

  // 상자 등급
  const boxRarity = Object.keys(boxGrade).map(key => ({
    key: boxGrade[key],
    value: key.toString(),
  }));

  // 플러스여부
  const IsPlus = [
    { value: null, label: '반짝임 여부 전체' },
    { value: true, label: 'O' },
    { value: false, label: 'X' },
  ];

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [isPlusTable, setIsPlusTable] = useState('');
  const [NFTGradeTable, setNFTGradesTable] = useState([]);
  const [NFTTypeTable, setNFTTypesTable] = useState([]);

  const [data, setData] = useState([{}]);
  const [beforeData, setBeforeData] = useState([{}]);
  const [currentData, setCurrentData] = useState([{}]);

  const [lineData, setLineData] = useState([{}]);

  const [graphType, setGraphType] = useState('count');

  const [isPlus, setIsPlus] = useState('');
  const [NFTGrade, setNFTGrades] = useState([]);
  const [NFTType, setNFTTypes] = useState([]);

  const [isReset, setIsReset] = useState(false);

  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  const schema = useSchemaMonitoringMarket();

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  // Excel Data
  const [excelData, setExcelData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    // 전체 선택시 빈값으로 대치
    const value = event.target.value.includes('')
          ? ['']
          : event.target.value;

    if (type === 'grade') {
      setNFTGrades(value);
    } else if (type === 'type') {
      setNFTTypes(value);
    } else if (type === 'grade-table') {
      setNFTGradesTable(value);
    } else if (type === 'type-table') {
      setNFTTypesTable(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraph(true);

    dispatch(
      statisticsCarBoxListRequest({
        beginDate: startAt,
        endDate: endAt,
        boxType: NFTType.map(item => String(item)).join(','),
        boxGrade: NFTGrade.map(item => String(item)).join(','),
        isPlus: isPlus === '' ? null : isPlus,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setData(data?.list)

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );

    // dispatch(
    //   statisticsCarBoxExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // );

  };

  // const handleClickDownload = () => {
  //   // 파일 명 설정
  //   const fileName = `마켓_차량상자_${startAt}_${endAt}`;
  //
  //   excelDownload(fileName, excelData, sortKey.statistics.market_carBox);
  // };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);

  useEffect(() => {
    fetchList();

    setIsLoading(true);

    // 등록 및 거래 현황 조회
    dispatch(
      statisticsCarBoxListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        boxType: '',
        boxGrade: '',
        isPlus: isPlusTable === '' ? null : isPlusTable,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list)

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );

    // dispatch(
    //   statisticsCarBoxExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // );
  }, []);

  useEffect(() => {
    setIsLoading(true);

    // 조건에 따른 등록 및 거래 현황 조회
    dispatch(
      statisticsCarBoxListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        boxType: NFTTypeTable.map(item => String(item)).join(','),
        boxGrade: NFTGradeTable.map(item => String(item)).join(','),
        isPlus: isPlusTable === '' ? null : isPlusTable,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list)

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [NFTTypeTable, NFTGradeTable, isPlusTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = data && data?.map(data => {
      // 등록
      const registerCount = data?.registerCount || 0;
      const minPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
      const maxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
      const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
      const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

      // 거래
      const transactionCount = data?.transactionCount || 0;
      const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
      const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
      const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
      const newDate = timeFormAPI.changeDataDate(data?.targetDate);

      if (graphType === 'count') {

        return {
          '등록 수량': registerCount || 0,
          '거래 수량': transactionCount || 0,

          time: newDate
        };

      } else if (graphType === 'token') {

        return {
          '최저 등록 금액': minPrice || 0,
          '최고 등록 금액': maxPrice || 0,
          '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
          '총 거래 금액': transactionTotalPrice || 0,
          '평균 거래 금액': transactionAveragePrice.toFixed() || 0,

          time: newDate
        };

      } else if (graphType === 'fee') {

        return {
          '총 거래 수수료': transactionTotalFee || 0,

          time: newDate
        };

      }

      return {
        '등록 수량': registerCount || 0,
        '최저 등록 금액': minPrice || 0,
        '최고 등록 금액': maxPrice || 0,
        '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
        '거래 수량': transactionCount || 0,
        '총 거래 금액': transactionTotalPrice || 0,
        '평균 거래 금액': transactionAveragePrice.toFixed(3) || 0,
        '총 거래 수수료': transactionTotalFee || 0,

        time: newDate
      };
    });

    setLineData(updateData)
  }, [data]);

  useEffect(() => {
    const updateData = strData && strData.map(data => {
      // 등록
      const registerCount = data?.registerCount || 0;
      const registerMinPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
      const registerMaxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
      const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
      const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

      // 거래
      const transactionCount = data?.transactionCount || 0;
      const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
      const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
      const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
      const targetDate = data?.targetDate;
      return {
        registerCount: registerCount,
        registerMinPrice: registerMinPrice,
        registerMaxPrice: registerMaxPrice,
        registerTotalPrice: registerTotalPrice,
        registerAveragePrice: registerAveragePrice.toFixed(3),
        transactionCount: transactionCount,
        transactionTotalPrice: transactionTotalPrice,
        transactionAveragePrice: transactionAveragePrice.toFixed(3),
        transactionTotalFee: transactionTotalFee,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);

    //   ------------------------------------

    setCurrentData(parseData(strData[1]))
    setBeforeData(parseData(strData[0]))

  }, [strData]);


  const parseData = (dataItem) => {
    const registerCount = dataItem?.registerCount || 0;
    const registerMinPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerMinPrice, 3)) || 0;
    const registerMaxPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerMaxPrice, 3)) || 0;
    const registerTotalPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerTotalPrice, 3)) || 0;
    const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

    const transactionCount = dataItem?.transactionCount || 0;
    const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(dataItem?.transactionTotalPrice, 3)) || 0;
    const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
    const transactionTotalFee = parseFloat(convertBigNumToDecimalString(dataItem?.transactionTotalFee, 3)) || 0;

    return {
      registerCount,
      registerMinPrice,
      registerMaxPrice,
      registerTotalPrice,
      registerAveragePrice: registerAveragePrice.toFixed(3),
      transactionCount,
      transactionTotalPrice,
      transactionAveragePrice: transactionAveragePrice.toFixed(3),
      transactionTotalFee,
      targetDate: dataItem?.targetDate,
    };
  };

  useEffect(() => {
      if(!isReset){
          return;
      }

      setIsReset(false);
      fetchList();

  }, [ isPlus, NFTGrade, NFTType ])


  // -- render --//
  return (
    <>
      <div className="contentsArea">
        <div className="rowDiv">
          <div className="leftDiv" style={{width:'100%'}}>
            <div className={"contentTitle"}>
              등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)` }
            </div>
          </div>

          <div className="rightDiv" style={{justifyContent: "flex-end"}}>
            <FormControl id={"formController"}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTTypeTable}
                  onChange={(event) => handleChange(event, 'type-table')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 상자 종류</div>;
                    }

                    return selected
                        .map((value) => boxTypes.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                  <input
                      type="checkbox"
                      checked={NFTTypeTable.length === boxTypes.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTTypesTable(checked ? boxTypes.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택" />
                </MenuItem>
                {boxTypes.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTTypeTable.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTTypesTable((prevNFTTypesTable) => {
                              if (checked) {
                                return [...prevNFTTypesTable, item.value];
                              } else {
                                return prevNFTTypesTable.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key} />
                    </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl id={"formController"}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTGradeTable}
                  onChange={(event) => handleChange(event, 'grade-table')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 상자 등급</div>;
                    }

                    return selected
                        .map((value) => boxRarity.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                  <input
                      type="checkbox"
                      checked={NFTGradeTable.length === boxRarity.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTGradesTable(checked ? boxRarity.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택" />
                </MenuItem>
                {boxRarity.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTGradeTable.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTGradesTable((prevNFTGradesTable) => {
                              if (checked) {
                                return [...prevNFTGradesTable, item.value];
                              } else {
                                return prevNFTGradesTable.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key} />
                    </MenuItem>
                ))}
              </Select>
            </FormControl>

            <select
                className=""
                value={isPlusTable}
                style={SELECT_FORM_STYLE}
                onChange={
                  (e) => {
                    console.log(e.target.value);
                    const selectedValue = e.target.value === 'true' ? true : e.target.value === 'false' ? false : null;
                    setIsPlusTable(selectedValue);
                  }
                }
            >
              {/*<option value={null} disabled selected>*/}
              {/*  반짝임 여부*/}
              {/*</option>*/}
              {IsPlus.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select>

          </div>

        </div>

        <div className="spaceDiv10"/>

        {
          isLoading ?
              <FetchLoading/>
              : <div style={{padding: "10px 15px"}}>
                <div className="rowDiv">
                  <DataItem
                      label="등록 수량"
                      value={ currentData?.registerCount || 0 }
                      prevValue={ beforeData?.registerCount || 0 }
                  />

                  <DataItem
                      label="최저 등록 금액"
                      value={ currentData?.registerMinPrice || 0 }
                      prevValue={beforeData?.registerMinPrice || 0}
                  />

                  <DataItem
                      label="최고 등록 금액"
                      value={ currentData?.registerMaxPrice || 0 }
                      prevValue={beforeData?.registerMaxPrice || 0}
                  />

                  <DataItem
                      label="평균 등록 금액"
                      value={ currentData?.registerAveragePrice || 0 }
                      prevValue={beforeData.registerAveragePrice || 0}
                  />
                  {/*  rowDiv*/}
                </div>

                <div className="spaceDiv10"/>
                <div className="spaceDiv10"/>

                <div className="rowDiv">
                  <DataItem
                      label="거래 수량"
                      value={currentData.transactionCount}
                      prevValue={beforeData.transactionCount}
                  />

                  <DataItem
                      label="총 거래 금액"
                      value={currentData.transactionTotalPrice}
                      prevValue={beforeData.transactionTotalPrice}
                  />

                  <DataItem
                      label="평균 거래 금액"
                      value={currentData.transactionAveragePrice}
                      prevValue={beforeData.transactionAveragePrice}
                  />

                  <DataItem
                      label="총 거래 수수료"
                      value={currentData.transactionTotalFee}
                      prevValue={beforeData.transactionTotalFee}
                  />
                </div>
              </div>

        }


      </div>
      {/* contentsArea */}


      <div className="spaceDiv10"/>



      {/*<div className="" style={{*/}
      {/*  display: 'flex',*/}
      {/*  gap: 5,*/}
      {/*  height: 'fit-content',*/}
      {/*  overflow: 'auto',*/}
      {/*}}>*/}

        {/*<div className="contentsArea" style={{*/}
        {/*  width: '100%',*/}
        {/*  height: '100%',*/}
        {/*}}>*/}
        {/*  <div className="contentTitle flex space-between" style={{ padding: 5 }}>*/}

        {/*    <div>*/}
        {/*      등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))}) 기준` }*/}
        {/*    </div>*/}

        {/*    <div style={{*/}
        {/*      display: 'flex',*/}
        {/*      gap: 5*/}
        {/*    }}>*/}

        {/*      <FormControl id={"formController"}>*/}
        {/*        <Select*/}
        {/*          displayEmpty*/}
        {/*          multiple*/}
        {/*          value={NFTTypeTable}*/}
        {/*          onChange={(event) => handleChange(event, 'type-table')}*/}
        {/*          renderValue={(selected) => {*/}
        {/*            if (selected.length === 0) {*/}
        {/*              return <div style={{ color: '#999' }}>차량 상자 종류</div>;*/}
        {/*            }*/}

        {/*            return selected*/}
        {/*              .map((value) => boxTypes.find((item) => item.value === value)?.key)*/}
        {/*              .filter(Boolean)*/}
        {/*              .join(', ');*/}
        {/*          }}*/}
        {/*          style={SELECT_FORM_STYLE}*/}
        {/*        >*/}
        {/*          <MenuItem value="all" style={{ padding: 5, gap: 5 }}>*/}
        {/*            <input*/}
        {/*              type="checkbox"*/}
        {/*              checked={NFTTypeTable.length === boxTypes.length}*/}
        {/*              onChange={(event) => {*/}
        {/*                const checked = event.target.checked;*/}
        {/*                setNFTTypesTable(checked ? boxTypes.map((item) => item.value) : []);*/}
        {/*              }}*/}
        {/*            />*/}
        {/*            <ListItemText primary="전체 선택" />*/}
        {/*          </MenuItem>*/}
        {/*          {boxTypes.map((item) => (*/}
        {/*            <MenuItem*/}
        {/*              key={item.value}*/}
        {/*              value={item.value}*/}
        {/*              style={{*/}
        {/*                padding: 5,*/}
        {/*                gap: 5*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              <input*/}
        {/*                type="checkbox"*/}
        {/*                checked={NFTTypeTable.includes(item.value)}*/}
        {/*                onChange={(event) => {*/}
        {/*                  const checked = event.target.checked;*/}
        {/*                  setNFTTypesTable((prevNFTTypesTable) => {*/}
        {/*                    if (checked) {*/}
        {/*                      return [...prevNFTTypesTable, item.value];*/}
        {/*                    } else {*/}
        {/*                      return prevNFTTypesTable.filter((value) => value !== item.value);*/}
        {/*                    }*/}
        {/*                  });*/}
        {/*                }}*/}
        {/*              />*/}
        {/*              <ListItemText primary={item.key} />*/}
        {/*            </MenuItem>*/}
        {/*          ))}*/}
        {/*        </Select>*/}
        {/*      </FormControl>*/}

        {/*      <FormControl id={"formController"}>*/}
        {/*        <Select*/}
        {/*          displayEmpty*/}
        {/*          multiple*/}
        {/*          value={NFTGradeTable}*/}
        {/*          onChange={(event) => handleChange(event, 'grade-table')}*/}
        {/*          renderValue={(selected) => {*/}
        {/*            if (selected.length === 0) {*/}
        {/*              return <div style={{ color: '#999' }}>차량 상자 등급</div>;*/}
        {/*            }*/}

        {/*            return selected*/}
        {/*              .map((value) => boxRarity.find((item) => item.value === value)?.key)*/}
        {/*              .filter(Boolean)*/}
        {/*              .join(', ');*/}
        {/*          }}*/}
        {/*          style={SELECT_FORM_STYLE}*/}
        {/*        >*/}
        {/*          <MenuItem value="all" style={{ padding: 5, gap: 5 }}>*/}
        {/*            <input*/}
        {/*              type="checkbox"*/}
        {/*              checked={NFTGradeTable.length === boxRarity.length}*/}
        {/*              onChange={(event) => {*/}
        {/*                const checked = event.target.checked;*/}
        {/*                setNFTGradesTable(checked ? boxRarity.map((item) => item.value) : []);*/}
        {/*              }}*/}
        {/*            />*/}
        {/*            <ListItemText primary="전체 선택" />*/}
        {/*          </MenuItem>*/}
        {/*          {boxRarity.map((item) => (*/}
        {/*            <MenuItem*/}
        {/*              key={item.value}*/}
        {/*              value={item.value}*/}
        {/*              style={{*/}
        {/*                padding: 5,*/}
        {/*                gap: 5*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              <input*/}
        {/*                type="checkbox"*/}
        {/*                checked={NFTGradeTable.includes(item.value)}*/}
        {/*                onChange={(event) => {*/}
        {/*                  const checked = event.target.checked;*/}
        {/*                  setNFTGradesTable((prevNFTGradesTable) => {*/}
        {/*                    if (checked) {*/}
        {/*                      return [...prevNFTGradesTable, item.value];*/}
        {/*                    } else {*/}
        {/*                      return prevNFTGradesTable.filter((value) => value !== item.value);*/}
        {/*                    }*/}
        {/*                  });*/}
        {/*                }}*/}
        {/*              />*/}
        {/*              <ListItemText primary={item.key} />*/}
        {/*            </MenuItem>*/}
        {/*          ))}*/}
        {/*        </Select>*/}
        {/*      </FormControl>*/}

        {/*       <select*/}
        {/*         className=""*/}
        {/*         value={isPlusTable}*/}
        {/*         style={SELECT_FORM_STYLE}*/}
        {/*         onChange={*/}
        {/*           (e) => {*/}
        {/*             console.log(e.target.value);*/}
        {/*             const selectedValue = e.target.value === 'true' ? true : e.target.value === 'false' ? false : null;*/}
        {/*             setIsPlusTable(selectedValue);*/}
        {/*           }*/}
        {/*         }*/}
        {/*       >*/}
        {/*         /!*<option value={null} disabled selected>*!/*/}
        {/*         /!*  반짝임 여부*!/*/}
        {/*         /!*</option>*!/*/}
        {/*         {IsPlus.map((option) => (*/}
        {/*           <option key={option.value} value={option.value}>*/}
        {/*             {option.label}*/}
        {/*           </option>*/}
        {/*         ))}*/}
        {/*       </select>*/}

        {/*    </div>*/}

        {/*  </div>*/}

        {/*  <div className="sectionLine"/>*/}

        {/*  {*/}
        {/*    isLoading ? (*/}
        {/*        <div className="rowDiv" style={{*/}
        {/*          width: '100%',*/}
        {/*          height: 210,*/}
        {/*          display: 'flex',*/}
        {/*          justifyContent: 'center',*/}
        {/*          padding: 5*/}
        {/*        }}>*/}
        {/*          Loading...*/}
        {/*        </div>*/}
        {/*      )*/}
        {/*      : tableData.slice(0, -1)*/}
        {/*      .map((data, index) => (*/}

        {/*        <div key={index}>*/}
        {/*          <div className="rowDiv" style={{*/}
        {/*            width: '100%',*/}
        {/*            height: '100%',*/}
        {/*            padding: 5*/}
        {/*          }}>*/}

        {/*            <div style={{*/}
        {/*              display: 'flex',*/}
        {/*              flexDirection: 'column',*/}
        {/*              justifyContent: 'center',*/}
        {/*              width: '100%',*/}
        {/*              height: '100%'*/}
        {/*            }}>*/}
        {/*              <div style={{*/}
        {/*                display: 'flex',*/}
        {/*                gap: 5*/}
        {/*              }}>*/}
        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                등록 수량<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.registerCount*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.registerCount,*/}
        {/*                  tableData[index + 1]?.registerCount,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                최저 등록 금액<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.registerMinPrice*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.registerMinPrice,*/}
        {/*                  tableData[index + 1]?.registerMinPrice,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                최고 등록 금액<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.registerMaxPrice*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.registerMaxPrice,*/}
        {/*                  tableData[index + 1]?.registerMaxPrice,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                평균 등록 금액<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.registerAveragePrice*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.registerAveragePrice,*/}
        {/*                  tableData[index + 1]?.registerAveragePrice,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}
        {/*            </div>*/}

        {/*          </div>*/}
        {/*        </div>*/}

        {/*        <div className="sectionLine" />*/}

        {/*        <div className="rowDiv" style={{*/}
        {/*          width: '100%',*/}
        {/*          height: '100%',*/}
        {/*          padding: 5*/}
        {/*        }}>*/}

        {/*          <div style={{*/}
        {/*            display: 'flex',*/}
        {/*            flexDirection: 'column',*/}
        {/*            justifyContent: 'center',*/}
        {/*            width: '100%',*/}
        {/*            height: '100%'*/}
        {/*          }}>*/}
        {/*            <div style={{*/}
        {/*              display: 'flex',*/}
        {/*              gap: 5*/}
        {/*            }}>*/}
        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                거래 수량<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.transactionCount*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.transactionCount,*/}
        {/*                  tableData[index + 1]?.transactionCount,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                총 거래 금액<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.transactionTotalPrice*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.transactionTotalPrice,*/}
        {/*                  tableData[index + 1]?.transactionTotalPrice,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                평균 거래 금액<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.transactionAveragePrice*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.transactionAveragePrice,*/}
        {/*                  tableData[index + 1]?.transactionAveragePrice,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}

        {/*              <div style={{*/}
        {/*                width: '25%',*/}
        {/*                fontSize: 14*/}
        {/*              }}>*/}
        {/*                총 거래 수수료<br />*/}
        {/*                <p style={{*/}
        {/*                  fontSize: 16,*/}
        {/*                  fontWeight: 700,*/}
        {/*                  color: '#141414'*/}
        {/*                }}>*/}
        {/*                  {*/}
        {/*                    tableData[index + 1]?.transactionTotalFee*/}
        {/*                  }*/}
        {/*                </p>*/}
        {/*                {DIFF_VALUE(*/}
        {/*                  tableData[index]?.transactionTotalFee,*/}
        {/*                  tableData[index + 1]?.transactionTotalFee,*/}
        {/*                  tableData[index + 1]?.targetDate*/}
        {/*                )}*/}
        {/*              </div>*/}
        {/*            </div>*/}

        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}

        {/*    ))*/}
        {/*  }*/}


        {/*</div>*/}

      {/*</div>*/}


      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
        </SearchRow>

        <SearchRow>
          <SearchLabel text={"차량 상자 종류"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTType}
                  onChange={(event) => handleChange(event, 'type')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 상자 종류</div>;
                    }

                    return selected
                        .map((value) => boxTypes.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={NFTType.length === boxTypes.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTTypes(checked ? boxTypes.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {boxTypes.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTType.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTTypes((prevNFTTypes) => {
                              if (checked) {
                                return [...prevNFTTypes, item.value];
                              } else {
                                return prevNFTTypes.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>

          </SearchContent>

          <SearchLabel text={"반짝임 여부"}/>
          <SearchContent>
            <select
                className=""
                value={isPlus}
                style={SELECT_FORM_STYLE}
                onChange={
                  (e) => {
                    console.log(e.target.value);
                    const selectedValue = e.target.value === 'true' ? true : e.target.value === 'false' ? false : null;
                    setIsPlus(selectedValue);
                  }
                }
            >
              {IsPlus.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select>

          </SearchContent>



        </SearchRow>

        <SearchRow>
          <SearchLabel text={"차랑 상자 등급"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTGrade}
                  onChange={(event) => handleChange(event, 'grade')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 상자 등급</div>;
                    }

                    return selected
                        .map((value) => boxRarity.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={NFTGrade.length === boxRarity.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTGrades(checked ? boxRarity.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {boxRarity.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTGrade.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTGrades((prevNFTGrades) => {
                              if (checked) {
                                return [...prevNFTGrades, item.value];
                              } else {
                                return prevNFTGrades.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>

          </SearchContent>

        </SearchRow>



      </SearchContainer>

      <SearchBtnContainer
          handleSearchClick={() => {
            fetchList();
          }}
          handleResetClick={() => {
              setIsPlus('');
              setNFTGrades([]);
              setNFTTypes([]);

              setStartAt(DAYS_AGO(activeDateRangeToken));
              setEndAt(DAYS_AGO(1))

              setIsReset(true);
          }}
      />

      <div className="spaceDiv10"/>

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        등록 및 거래 내역 조회*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="spaceDiv10"/>*/}
      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={NFTType}*/}
      {/*          onChange={(event) => handleChange(event, 'type')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>차량 상자 종류</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => boxTypes.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={NFTType.length === boxTypes.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setNFTTypes(checked ? boxTypes.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {boxTypes.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTType.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTTypes((prevNFTTypes) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevNFTTypes, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevNFTTypes.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={NFTGrade}*/}
      {/*          onChange={(event) => handleChange(event, 'grade')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>차량 상자 등급</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => boxRarity.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={NFTGrade.length === boxRarity.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setNFTGrades(checked ? boxRarity.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {boxRarity.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTGrade.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTGrades((prevNFTGrades) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevNFTGrades, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevNFTGrades.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*       <select*/}
      {/*         className=""*/}
      {/*         value={isPlus}*/}
      {/*         style={SELECT_FORM_STYLE}*/}
      {/*         onChange={*/}
      {/*           (e) => {*/}
      {/*             console.log(e.target.value);*/}
      {/*             const selectedValue = e.target.value === 'true' ? true : e.target.value === 'false' ? false : null;*/}
      {/*             setIsPlus(selectedValue);*/}
      {/*           }*/}
      {/*         }*/}
      {/*       >*/}
      {/*         <option value={null} disabled>*/}
      {/*           반짝임 여부*/}
      {/*         </option>*/}
      {/*         {IsPlus.map((option) => (*/}
      {/*           <option key={option.value} value={option.value}>*/}
      {/*             {option.label}*/}
      {/*           </option>*/}
      {/*         ))}*/}
      {/*       </select>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'count' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('count');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수량*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'token' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('token');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        금액*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'fee' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('fee');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수수료*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList();*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      /!*<button className="defaultBtn fit purple" onClick={handleClickDownload}>*!/*/}
      {/*      /!*  <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*!/*/}
      {/*      /!*  엑셀 다운로드*!/*/}
      {/*      /!*</button>*!/*/}

      {/*    </div>*/}
      {/*  </div>*/}


      {/*  /!*{*!/*/}
      {/*  /!*  isLoadingGraph ? (*!/*/}
      {/*  /!*      <div className="rowDiv" style={{*!/*/}
      {/*  /!*        width: '100%',*!/*/}
      {/*  /!*        height: 520,*!/*/}
      {/*  /!*        display: 'flex',*!/*/}
      {/*  /!*        justifyContent: 'center',*!/*/}
      {/*  /!*        padding: 'unset'*!/*/}
      {/*  /!*      }}>*!/*/}
      {/*  /!*        Loading...*!/*/}
      {/*  /!*      </div>*!/*/}
      {/*  /!*    )*!/*/}
      {/*  /!*    : <div className="rowDiv" style={{*!/*/}
      {/*  /!*  height: 520,*!/*/}
      {/*  /!*  padding: 'unset'*!/*/}
      {/*  /!*}}>*!/*/}
      {/*  /!*  <div className="descDiv" style={{*!/*/}
      {/*  /!*    width: '100%',*!/*/}
      {/*  /!*    height: '100%'*!/*/}
      {/*  /!*  }}>*!/*/}
      {/*  /!*    <SimpleLine data={lineData}/>*!/*/}
      {/*  /!*  </div>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*  /!*}*!/*/}
      {/*</div>*/}

      <div className="spaceDiv10"/>

      <BOTable
          schema={schema}
          rows={data}
          loading={isLoadingGraph}
          maxHeight={"55vh"}
      />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </>
  );
}

export default carBox;
